module.exports = __webpack_public_path__ + "static/media/anage-profissionais@2x.abe56181.png";